export default __webpack_public_path__ + "static/media/startButton.0686074a.svg";